import { ViewModelProperty } from '@lfw/roesberg';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../../appconfig';
import { stateTranslator } from '../helpers/state-translator';

export class Languages {
  public readonly availableLanguages: string[];
  private readonly defaultLangIdx: number;
  private currentLangIdx = -1;

  constructor(
    private readonly config: AppConfig,
    private readonly translate: TranslateService
  ) {
    this.availableLanguages = ['en', 'de'];
    this.defaultLangIdx = this.getLanguageIdx(config.defaultLanguage());
  }

  // The server's list is stored per installation and outlives the code, so it can still offer a
  // language whose assets/i18n file no longer exists.
  restrictValueListToAvailable(item: ViewModelProperty): void {
    if (!item.valueList) {
      return;
    }

    const supported = item.valueList.filter((language) =>
      this.availableLanguages.includes(language.trim().toLowerCase())
    );

    if (supported.length > 0) {
      item.valueList = supported;
    }
  }

  /**
   * gets the number of the currently selected language
   */
  getSelectedlanguage() {
    return this.currentLangIdx;
  }

  /**
   * gets the iso name of the currently selected language
   */
  getSelectedlanguageISO() {
    return this.availableLanguages[this.currentLangIdx];
  }

  /**
   * selects the new language and applies it
   * @param index theme number
   */
  setSelectedlanguage(index: number) {
    this.changeLanguage(index);
  }

  /**
   * selects the new language and applies it
   * @param name language
   */
  setSelectedLanguageByName(name: string) {
    if (name === null || name === '') {
      return;
    }
    name = name.toLowerCase();
    const idx = this.availableLanguages.indexOf(name);
    if (idx >= 0) {
      this.changeLanguage(idx);
    }
  }

  private getLanguageIdx(lang: string): number {
    let idx = this.availableLanguages.indexOf(lang);
    if (idx < 0) {
      idx = 0;
    }
    return idx;
  }

  /**
   * applies the previous selected language
   */
  applyLanguage() {
    if (this.currentLangIdx >= 0 && this.currentLangIdx < this.availableLanguages.length) {
      this.changeLanguage(this.currentLangIdx);
    } else {
      this.changeLanguage(this.defaultLangIdx);
    }
  }

  changeLanguage(index: number) {
    this.translate.use(this.availableLanguages[index]);
    stateTranslator.translateStates(this.translate);
    this.currentLangIdx = index;
  }
}
